const EXTENSION_FRAME = /(chrome|moz|safari-web)-extension:\/\//;

/**
 * True when every frame of the stack belongs to a browser extension.
 *
 * Extensions inject scripts into our pages, and their rejections land in our
 * `unhandledrejection` handler as if they were ours. One extension's
 * `reading 'M_ID'` bug produced more prod issues than all of apps/web combined.
 * A stack with even one non-extension frame is kept — that is our code being
 * called by, or calling into, the extension, and could be our bug.
 */
export function isForeignExtensionError(error: unknown): boolean {
  const stack = error instanceof Error ? error.stack : undefined;
  if (!stack) return false;

  const frames = stack.split('\n').filter((line) => /^\s*at\s|@/.test(line));
  return frames.length > 0 && frames.every((frame) => EXTENSION_FRAME.test(frame));
}
